import { render, staticRenderFns } from "./BansSubscription.vue?vue&type=template&id=2a385db5"
import script from "./BansSubscription.vue?vue&type=script&lang=js"
export * from "./BansSubscription.vue?vue&type=script&lang=js"
import style0 from "./BansSubscription.vue?vue&type=style&index=0&id=2a385db5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports